export const MAIN_HEADER_HEIGHT = 48
export const PAGE_HEADER_HEIGHT = 57
export const PAGE_HEADER_HEIGHT_EMPHASIZED = 110
export const PADDING_GAP = 20
export const COMPONENT_HEADER_HEIGHT = 69
export const COMPONENT_HEADER_HEIGHT_EMPHASIZED = 110
export const TABLE_HEADER_HEIGHT = 48.5
export const MAIN_CONTENT_HEIGHT = `calc(100vh - ${MAIN_HEADER_HEIGHT * 2}px)`
export const MAIN_CONTENT_HEIGHT_LESS_PAGE_HEADER = `calc(100vh - ${MAIN_HEADER_HEIGHT * 2}px - ${PAGE_HEADER_HEIGHT}px)`
export const MAIN_CONTENT_HEIGHT_LESS_PAGE_HEADER_EMPHASIZED = `calc(100vh - ${MAIN_HEADER_HEIGHT * 2}px - ${PAGE_HEADER_HEIGHT_EMPHASIZED}px)`
export const SIDEBAR_WIDTH = 280
export const MAIN_CONTENT_WIDTH = `calc(100vw - ${SIDEBAR_WIDTH}px)`
export const TOTAL_HEADINGS_AND_SPACING = MAIN_HEADER_HEIGHT * 2 + PAGE_HEADER_HEIGHT + PADDING_GAP * 2
export const TOTAL_HEADINGS_AND_SPACING_EMPHASIZED =
  MAIN_HEADER_HEIGHT * 2 + PAGE_HEADER_HEIGHT_EMPHASIZED + PADDING_GAP * 2
export const CONTENT_HEIGHT = `calc(100vh - ${TOTAL_HEADINGS_AND_SPACING}px)`
export const GRID_ROW_HEIGHT = `calc((100vh - ${TOTAL_HEADINGS_AND_SPACING}px)/2 - ${PADDING_GAP / 2}px)`
export const GRID_ROW_HEIGHT_EMPHASIZED = `calc((100vh - ${TOTAL_HEADINGS_AND_SPACING_EMPHASIZED}px)/2 - ${PADDING_GAP / 2}px)`
export const GRID_ROW_HEIGHT_NO_HEADER = `calc((100vh - ${MAIN_HEADER_HEIGHT * 2 + PADDING_GAP * 2}px)/2 - ${PADDING_GAP / 2}px)`
export const SUPPORT_PANEL_WIDTH = `calc(50vw - ${SIDEBAR_WIDTH + PADDING_GAP}px)`
